import { useCallback, useMemo } from 'react'
import Button from '@aura/components/button'
import Grid from '@aura/components/grid'
import { withStyles } from '@aura/components/styles'
import Paper from '@aura/components/paper'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import Typography from '@aura/components/typography'
import RegistrationContainer from '../../../../components/new-registration-container'
import styles from './styles'


const Component = ({
    classes,
    onNext
}) => {

    const { t: translate, i18n } = useTranslation()
    const isHedgexUser = sessionStorage.getItem('hedgexMigration') === 'true'
    const isAAGUser = sessionStorage.getItem('aagMigration') === 'true'

    const title = translate('welcome')
    const cards = useMemo(() => [
        {
            description: translate('registrationWelcome.card1desc'), id: 1, title: translate('registrationWelcome.card1Title')
        }, {
            description: translate('registrationWelcome.card2desc'), id: 2, title: translate('registrationWelcome.card2Title')
        }, {
            description: translate('registrationWelcome.card3desc'), id: 3, title: translate('registrationWelcome.card3Title')
        } 
    ], [ i18n.language ])
    const getCard = ({ id, title, description }) => {
        return  <Paper key={id} className={classes.card}>
            <div className={classes.cardNumber}>{id}</div>
            <div className={`${classes.subCardTitle}`}>{title}</div>
            <div className={`${classes.description} ${id === 2 && classes.secondBoxdescription }`}>{description}</div>
        </Paper>
    }
    const footerContent = (
        <Grid className={classes.buttonContainer}>
            <Button
                className={classes.button}
                color='primary'
                onClick={useCallback(() => onNext())}>
                {translate('letsGetStarted')}
            </Button>
        </Grid>
    )
    const mainContent = (
        <>
            <div className={classes.introText}>
                <Typography className={classes.cardTitle}>{translate('registrationWelcome.mainTitle')}</Typography>
                <p className={classes.subTitle}>
                    {isAAGUser
                        ? translate('registrationWelcome.aagSubtitle')
                        : isHedgexUser 
                            ? translate('registrationWelcome.hedgexSubtitle')
                            : translate('registrationWelcome.mainSubtitle')
                    }
                </p>
            </div>
            <div className={classes.cardsContainer}>
                {cards.map(({ description, id, title }) =>
                    getCard({ description, id, title })
                )}
            </div>
            <div className={classes.helpText}>
                <p className={classes.subTitle}>{translate('registrationFlow.helpText')}</p>
            </div>
        </>
    )
    return (<RegistrationContainer {...{ footerActions : footerContent,mainContent, title }}>        
    </RegistrationContainer>)
}

Component.displayName = 'RegistrationWelcome'


Component.propTypes = {
    classes: PropTypes.shape({
        button: PropTypes.object,
        buttonContainer: PropTypes.object
    }),
    onNext: PropTypes.func.isRequired
}

export default withStyles(Component, styles)
